import { Image, List, InfoIcon } from "../../../../api/components";
import * as React from 'react';
export default {
  Image,
  List,
  InfoIcon,
  React
};